import { Flex } from "@chakra-ui/react";
import React, { useEffect } from "react";
import axios from "axios";
import Individual from "./components/Individual";
import { getToken } from "utils/auth";
import config from "config";

function Data() {

  useEffect(() => {
    
    const fetchIndividuals = async () => {
      try {
        const token = getToken()
        const response = await axios.get(`${config.API_URL}/individuals/1`,
          {
            headers: { Authorization: `Bearer ${token}` },
          });
        console.log(response)
      } catch (error) {
        console.error("Error fetching profile information:", error);
      }
    };

    fetchIndividuals();
    
  }, []);

  return (
    <Flex direction="column" pt={{ base: "62px", md: "75px", xl: "88px" }}>
      <Individual
      />
    </Flex>
  );
}

export default Data;
